import { UpperScreen } from "../../../../actions/terminal";
import { broadcast, broadcastChannels } from "../../../../helpers/broadcast";
import Helpers from "../../../../helpers/helperFunctions";
import { store } from "../../../../index/terminalApp";
import Config from "../../../../config/main";

class GoldenRaceHandler {
    constructor() {
        this._hardwareId = null
    }

    getStreamURL(playlistId) {
        const sportAlias = Config.thirdParty.goldenRaceStreamTempSportsMap[playlistId];
        return sportAlias ? `${Config.thirdParty.goldenRaceStreamURL}/${this._hardwareId}/${sportAlias}` : '';
    }

    openStream(sportName) {
        const streamURL = this.getStreamURL(sportName);

        if (streamURL) {
            Helpers.isSplitScreenAvailable()
                ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                    detail: { command: 'ThirdParty', url: streamURL }
                })) : store.dispatch(UpperScreen({
                    type: "ThirdParty",
                    id: 111, //doesn't matter what id
                    videoURL: streamURL,
                    tv_type: 21,
                }));
        }
    }

    onIframeMessage({ data }) {
        if (data?.hardwareId) this._hardwareId = data.hardwareId;
        this._hardwareId && data?.descriptionTag && this.openStream(data.id);
    }
};

export default GoldenRaceHandler;